import React, { useEffect, useState } from "react"
import {
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    Button,
    Alert
} from "reactstrap"
import { connect } from "react-redux"
import { setBreadcrumbItems } from "../../store/actions"
import { whatsappAPI } from "../../services/api"

const WhatsAppSettings = (props) => {
    document.title = "Configuration WhatsApp | Ticket Management"

    const [status, setStatus] = useState({ connected: false, qr: null })
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)

    const breadcrumbItems = [
        { title: "Dashboard", link: "/dashboard" },
        { title: "Paramètres", link: "#" },
        { title: "WhatsApp", link: "#" },
    ]

    useEffect(() => {
        props.setBreadcrumbItems("Configuration WhatsApp", breadcrumbItems)
        const interval = setInterval(fetchStatus, 3000)
        fetchStatus()
        return () => clearInterval(interval)
    }, [])

    const fetchStatus = async () => {
        try {
            const res = await whatsappAPI.getStatus()
            setStatus(res.data)
            setError(null)
        } catch (err) {
            setError("Impossible de se connecter au service WhatsApp. Assurez-vous que le service bridge est démarré.")
        } finally {
            setLoading(false)
        }
    }

    const handleLogout = async () => {
        if (window.confirm("Êtes-vous sûr de vouloir déconnecter WhatsApp ?")) {
            try {
                await whatsappAPI.logout()
                fetchStatus()
            } catch (err) {
                console.error("Erreur déconnexion", err)
            }
        }
    }

    return (
        <React.Fragment>
            <Row>
                <Col lg={6} className="mx-auto">
                    <Card>
                        <CardBody className="text-center">
                            <CardTitle className="h4 mb-4">Statut de la Connexion WhatsApp</CardTitle>

                            {error && (
                                <Alert color="danger">{error}</Alert>
                            )}

                            {loading ? (
                                <div className="py-5">
                                    <div className="spinner-border text-primary" role="status">
                                        <span className="sr-only">Chargement...</span>
                                    </div>
                                </div>
                            ) : (
                                <div className="py-3">
                                    {status.connected ? (
                                        <div className="text-center">
                                            <div className="mb-4">
                                                <i className="mdi mdi-check-circle text-success" style={{ fontSize: "80px" }}></i>
                                            </div>
                                            <h5 className="text-success mb-3">Connecté</h5>
                                            <p className="text-muted mb-4">
                                                Votre compte WhatsApp est actuellement lié et prêt à envoyer des notifications.
                                            </p>
                                            <Button color="danger" outline onClick={handleLogout}>
                                                <i className="mdi mdi-logout me-1"></i> Déconnecter
                                            </Button>
                                        </div>
                                    ) : (
                                        <div className="text-center">
                                            <div className="mb-4">
                                                <i className="mdi mdi-whatsapp text-muted" style={{ fontSize: "80px" }}></i>
                                            </div>
                                            <h5 className="mb-3">Non connecté</h5>
                                            <p className="text-muted mb-4">
                                                Pour envoyer des notifications WhatsApp, vous devez scanner le code QR ci-dessous avec votre application WhatsApp (Appareils connectés).
                                            </p>

                                            {status.qr ? (
                                                <div className="bg-light p-4 d-inline-block rounded border mb-4">
                                                    <img src={status.qr} alt="Scan me" style={{ maxWidth: "250px" }} />
                                                    <div className="mt-2 small text-muted">
                                                        Le code se rafraîchit automatiquement
                                                    </div>
                                                </div>
                                            ) : (
                                                <div className="py-4">
                                                    {status.status === "initializing" || !status.status ? (
                                                        <p className="text-info">Initialisation du service WhatsApp...</p>
                                                    ) : status.status === "disconnected" ? (
                                                        <p className="text-warning">Service déconnecté. Préparation du nouveau QR code...</p>
                                                    ) : (
                                                        <p className="text-info">Génération du code QR en cours...</p>
                                                    )}
                                                    <div className="spinner-grow text-info spinner-grow-sm ms-2" role="status"></div>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            )}
                        </CardBody>
                    </Card>

                    <Card className="mt-4">
                        <CardBody>
                            <h5 className="font-size-15">Instructions :</h5>
                            <ol className="text-muted mb-0">
                                <li className="mb-2">Ouvrez WhatsApp sur votre téléphone.</li>
                                <li className="mb-2">Appuyez sur <strong>Menu</strong> ou <strong>Réglages</strong> et sélectionnez <strong>Appareils connectés</strong>.</li>
                                <li className="mb-2">Appuyez sur <strong>Connecter un appareil</strong>.</li>
                                <li className="mb-0">Pointez votre téléphone vers cet écran pour scanner le code.</li>
                            </ol>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </React.Fragment>
    )
}

export default connect(null, { setBreadcrumbItems })(WhatsAppSettings)
